import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SedsCheckFormTypeService {
  public isReactiveForm(hasModelParameter: any, hasControlParameter: any): boolean | void {
    if (hasModelParameter && !hasControlParameter) {
      return false;
    }

    if (!hasModelParameter && hasControlParameter) {
      return true;
    }

    if (hasModelParameter && hasControlParameter) {
      console.warn(
        'Review the parameters sent to SEDS component! Pass only one form type parameter (Model or Control)'
      );
    }
  }
}
